var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.0938C9.53906 10.0938 9.07701 10.625 7.5 10.625C5.92299 10.625 5.46429 10.0938 4.5 10.0938C2.01562 10.0938 0 12.0926 0 14.5562V15.4062C0 16.2861 0.719866 17 1.60714 17H13.3929C14.2801 17 15 16.2861 15 15.4062V14.5562C15 12.0926 12.9844 10.0938 10.5 10.0938ZM13.3929 15.4062H1.60714V14.5562C1.60714 12.9758 2.90625 11.6875 4.5 11.6875C4.98884 11.6875 5.78237 12.2188 7.5 12.2188C9.23103 12.2188 10.0078 11.6875 10.5 11.6875C12.0938 11.6875 13.3929 12.9758 13.3929 14.5562V15.4062ZM7.5 9.5625C10.1618 9.5625 12.3214 7.4209 12.3214 4.78125C12.3214 2.1416 10.1618 0 7.5 0C4.83817 0 2.67857 2.1416 2.67857 4.78125C2.67857 7.4209 4.83817 9.5625 7.5 9.5625ZM7.5 1.59375C9.2712 1.59375 10.7143 3.0248 10.7143 4.78125C10.7143 6.5377 9.2712 7.96875 7.5 7.96875C5.72879 7.96875 4.28571 6.5377 4.28571 4.78125C4.28571 3.0248 5.72879 1.59375 7.5 1.59375Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.af57ed5d.svg";
export { ForwardRef as ReactComponent };